import { camelizeKeys } from 'humps';
import {
  formatAsUriParameters,
  get,
  post,
  validateScheme
} from '@namespace/helpers';
import { PAYMENTS_COMMON_REQ_PARAMS } from '../constants';
import {
  addTokenResponseDataShema,
  getTokenResponseDataShema,
  updateTokenResponseDataShema
} from './shemas';
import {
  AddTokenParams,
  AddTokenResponseData,
  GetTokensParams,
  GetTokensResponseData,
  UpdateTokenParams,
  UpdateTokenResponseData
} from './types';

export const getTokens = (params: GetTokensParams) => {
  const queryParams = formatAsUriParameters(params);
  return get<GetTokensResponseData>({
    url: `/accounting/api/v1/payment_accounts?${queryParams}`,
    ...PAYMENTS_COMMON_REQ_PARAMS
  }).then((data) => {
    validateScheme(getTokenResponseDataShema, data, {
      name: 'getTokens'
    });

    return camelizeKeys<GetTokensResponseData>(data);
  });
};

export const addToken = (params: AddTokenParams) => {
  return post<AddTokenResponseData>({
    url: '/accounting/api/v1/payment_accounts',
    body: params,
    ...PAYMENTS_COMMON_REQ_PARAMS
  }).then((data) => {
    validateScheme(addTokenResponseDataShema, data, {
      name: 'addToken'
    });

    return camelizeKeys<AddTokenResponseData>(data);
  });
};

export const updateToken = (params: UpdateTokenParams) => {
  return post<UpdateTokenResponseData>({
    url: '/accounting/api/v1/payment_accounts/update',
    body: params,
    ...PAYMENTS_COMMON_REQ_PARAMS
  }).then((data) => {
    validateScheme(updateTokenResponseDataShema, data, {
      name: 'updateToken'
    });

    return camelizeKeys<UpdateTokenResponseData>(data);
  });
};
